// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"PokemonCards_mainContainer__1qUEP","deleteButton":"PokemonCards_deleteButton__1dZ0H","uncatchButton":"PokemonCards_uncatchButton__2g2KP"};